/**
 * Legend.jsx
 * ==========
 * Color legend for crop types and growth stages.
 * Switches between modes based on the viewMode prop.
 */

import React from 'react';

const CROP_LEGEND = [
  { label: 'Paddy',     color: '#00FF00', icon: '🌾' },
  { label: 'Sugarcane', color: '#FFD700', icon: '🎋' },
  { label: 'Banana',    color: '#FF6B35', icon: '🍌' },
  { label: 'Coconut',   color: '#228B22', icon: '🥥' },
  { label: 'Groundnut', color: '#DEB887', icon: '🥜' },
  { label: 'Fallow',    color: '#8B4513', icon: '🟫' },
];

const STAGE_LEGEND = [
  { label: 'Early (Seedling)',        color: '#FFFF00', icon: '🌱' },
  { label: 'Intermediate (Growing)',  color: '#90EE90', icon: '🌿' },
  { label: 'Mature (Harvest-ready)',  color: '#006400', icon: '🌾' },
  { label: 'Harvested (Stubble)',     color: '#A0522D', icon: '🏜️' },
];

export default function Legend({ viewMode }) {
  const items = viewMode === 'crop' ? CROP_LEGEND : STAGE_LEGEND;
  const title = viewMode === 'crop' ? '🌾 Crop Types' : '📈 Growth Stages';

  return (
    <div>
      <div className="text-xs font-bold text-slate-400 mb-1.5 uppercase tracking-wider">
        {title}
      </div>
      <div className="grid grid-cols-2 gap-x-3 gap-y-1">
        {items.map(({ label, color, icon }) => (
          <div key={label} className="flex items-center gap-1.5">
            <div
              className="w-3 h-3 rounded-sm flex-shrink-0 border border-black/20"
              style={{ background: color }}
            />
            <span className="text-xs text-slate-300 leading-tight truncate" title={label}>
              {label}
            </span>
          </div>
        ))}
      </div>

      {/* Map element legend */}
      <div className="mt-2 pt-2 border-t border-slate-700/50 space-y-1">
        <div className="flex items-center gap-1.5">
          <div className="w-6 h-0.5" style={{ background: '#FFD700' }} />
          <span className="text-xs text-slate-500">Parcel boundary</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-6 h-0.5" style={{ background: '#ef4444' }} />
          <span className="text-xs text-slate-500">Village / Taluk border</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-6 h-0.5 border-t-2 border-dashed border-white/40" />
          <span className="text-xs text-slate-500">Selected parcel</span>
        </div>
      </div>
    </div>
  );
}
